
import { defineComponent } from 'vue';
import ShoppingList from './components/ShoppingList.vue';

export default defineComponent({
  name: 'App',
  components: {
    ShoppingList
  },
  data: function() {
    return {
      list: ['Potatoes 🥔','Corn 🌽', 'Soy milk 🥛', 'Carrots 🥕'],
      text: '',
      index: null,
    }
  },
  methods: {
    addItem() {
      this.list.push(this.text);
    },
    deleteItem(index: number) {
      console.log(index)
      this.list.splice(index, 1);
    }
  }
});
